interface PlanFeature {
  text: string;
}

export interface Plan {
  key: string;
  name: string;
  price: string;
  description: string;
  features: PlanFeature[];
  ctaLabel: string;
  selectable?: boolean;
  highlighted?: boolean;
  badge?: string;
}

export const PLANS: Plan[] = [
  {
    key: 'free',
    name: 'Free',
    price: 'GHS0/month',
    description: 'Get started with risk management at no cost.',
    features: [
      { text: '1 business' },
      { text: 'Basic hedging tools' },
      { text: 'Community support' },
    ],
    ctaLabel: 'Get started',
    selectable: true,
  },
  {
    key: 'basic',
    name: 'Basic',
    price: 'GHS200/month',
    description: 'Higher limits for regular risk management work.',
    features: [
      { text: '3 businesses' },
      { text: 'All hedging strategies' },
      { text: 'Email support' },
    ],
    ctaLabel: 'Get started',
    selectable: true,
  },
  {
    key: 'pro',
    name: 'Pro',
    price: 'GHS1000/month',
    description: 'For teams who need more power and flexibility.',
    features: [
      { text: '10 businesses' },
      { text: 'Everything in Basic' },
      { text: 'Priority support' },
    ],
    ctaLabel: 'Get started',
    selectable: true,
    highlighted: true,
    badge: 'MOST POPULAR',
  },
  {
    key: 'enterprise',
    name: 'Enterprise',
    price: 'Custom',
    description: 'For large organizations with advanced security and compliance needs.',
    features: [
      { text: 'Custom business limit' },
      { text: 'Everything in Pro' },
      { text: 'SSO & SAML authentication' },
      { text: 'Dedicated account manager' },
      { text: 'Custom integrations' },
      { text: 'On-premise deployment option' },
    ],
    ctaLabel: 'Contact sales',
  },
];

export const FEATURES = [
  'Get price insights from prediction markets',
  'Buy/sell smarter in volatile markets by hedging your positions',
] as const;
